import React from 'react'
import { observer } from 'mobx-react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useStores } from 'hooks/useStores'
import classNames from 'classnames'
import routes from 'routes'
import styles from './adminHeader.module.scss'

interface AdminHeaderProps {
  // Add any props if needed in the future
}

interface AdminNavItem {
  label: string
  path: string
  isActive?: boolean
}

const AdminHeader: React.FC<AdminHeaderProps> = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { authStore } = useStores()

  const adminNavItems: AdminNavItem[] = [
    {
      label: '🏠 Welcome',
      path: routes.admin.value,
    },
    {
      label: '📊 Reports',
      path: routes.admin.report.value,
    },
    {
      label: '📝 Release Notes',
      path: routes.admin.releaseNotes.value,
    },
  ]

  const isActiveRoute = (path: string): boolean => {
    if (path === routes.admin.value) {
      // For dashboard, only match exact path
      return location.pathname === path
    }
    // For other routes, match if pathname starts with the route path
    return location.pathname.startsWith(path)
  }

  const handleNavigation = (path: string) => {
    navigate(path)
  }

  const getUserInitials = () => {
    const userDetail = authStore?.userDetail
    if (!userDetail) return 'A'
    
    const firstName = userDetail.firstName || ''
    const lastName = userDetail.lastName || ''
    
    if (firstName && lastName) {
      return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase()
    }
    
    if (firstName) {
      return firstName.charAt(0).toUpperCase()
    }
    
    return 'A'
  }

  const getUserDisplayName = () => {
    const userDetail = authStore?.userDetail
    if (!userDetail) return 'Admin'
    
    const firstName = userDetail.firstName || ''
    const lastName = userDetail.lastName || ''
    
    if (firstName && lastName) {
      return `${firstName} ${lastName}`
    }
    
    if (firstName) {
      return firstName
    }
    
    return 'Admin'
  }

  return (
    <div className={styles.headerContainer}>
      <div className={styles.navContainer}>
        {/* Admin Panel Title */}
        <div className={styles.title}>
          ⚡ Admin Panel
        </div>

        {/* Navigation Tabs */}
        <div className={styles.navTabs}>
          {adminNavItems.map((item) => {
            const isActive = isActiveRoute(item.path)
            return (
              <button
                key={item.path}
                className={classNames(styles.navTab, {
                  [styles.active]: isActive,
                })}
                onClick={() => handleNavigation(item.path)}
              >
                {item.label}
              </button>
            )
          })}
        </div>

        {/* Right Section */}
        <div className={styles.rightSection}>
          <div className={styles.userInfo}>
            Welcome, {getUserDisplayName()}
          </div>
          <div className={styles.profileButton}>
            {getUserInitials()}
          </div>
        </div>
      </div>
    </div>
  )
}

export default observer(AdminHeader)
